module.exports = __webpack_public_path__ + "static/img/avatar1.777f87d2.png";